module.exports = __webpack_public_path__ + "img/motorbikeOverview3.cdb2c2be.svg";